import { useNavigate } from "react-router-dom";
import {
  MdArrowForward,
  MdArrowBack,
  MdEast,
  MdDirectionsBus,
  MdAccessTime,
} from "react-icons/md";
import {
  TripCard,
  TripCardBody,
  TripCardTop,
  TagBadge,
  DirectionLabel,
  RouteSection,
  TripPoint,
  TripPointLabel,
  TripPointValue,
  RouteArrow,
  MetaRow,
  MetaItem,
  StatusDot,
  TripCardFooter,
  DayChip,
} from "./styled";

const ALL_DAYS = [
  { key: "seg", label: "Seg" },
  { key: "ter", label: "Ter" },
  { key: "qua", label: "Qua" },
  { key: "qui", label: "Qui" },
  { key: "sex", label: "Sex" },
  { key: "sab", label: "Sab" },
  { key: "dom", label: "Dom" },
];

function TabelaV(props) {
  const navigate = useNavigate();

  function filterDesc(desc) {
    if (desc.length < 28) {
      return desc;
    }
    return `${desc.substring(0, 25)}...`;
  }

  const mapaR = () => {
    localStorage.setItem("BuslineShiftID", props.data.id);
    return navigate("/mapa");
  };

  const directionName = props.data.direction.direction_name;
  const isIda = directionName.toLowerCase() === "ida";

  const unitLabel =
    props.data.unit.label !== null
      ? filterDesc(props.data.unit.label)
      : "Unidade nao cadastrada";

  // Calcular duracao estimada a partir dos horarios
  const calcDuration = () => {
    try {
      const [hStart, mStart] = props.data.hour.split(":").map(Number);
      const [hEnd, mEnd] = props.data.hour_end.split(":").map(Number);
      let diffMin = hEnd * 60 + mEnd - (hStart * 60 + mStart);
      if (diffMin < 0) diffMin += 24 * 60;
      const hours = Math.floor(diffMin / 60);
      const mins = diffMin % 60;
      if (hours > 0) return `${hours}h${mins > 0 ? `${mins}min` : ""}`;
      return `${mins}min`;
    } catch {
      return null;
    }
  };

  const duration = calcDuration();

  // Dias ativos (normalizado para lowercase)
  const activeDays = props.data.weekday.map((w) => w.toLowerCase());

  return (
    <TripCard onClick={() => mapaR()}>
      <TripCardBody>
        <TripCardTop>
          <TagBadge>{props.data.tag}</TagBadge>
          <DirectionLabel>
            {isIda ? <MdArrowForward size={16} /> : <MdArrowBack size={16} />}
            {directionName}
          </DirectionLabel>
        </TripCardTop>

        <RouteSection>
          <TripPoint>
            <TripPointLabel>Inicio</TripPointLabel>
            <TripPointValue title={props.data.hour}>
              {props.data.hour}
            </TripPointValue>
          </TripPoint>
          <RouteArrow>
            <MdEast size={20} />
          </RouteArrow>
          <TripPoint>
            <TripPointLabel>Fim</TripPointLabel>
            <TripPointValue title={props.data.hour_end}>
              {props.data.hour_end}
            </TripPointValue>
          </TripPoint>
        </RouteSection>

        <MetaRow>
          <MetaItem>
            <MdDirectionsBus size={14} />
            {unitLabel}
          </MetaItem>
          {duration && (
            <MetaItem>
              <MdAccessTime size={14} />
              {duration}
            </MetaItem>
          )}
          <MetaItem>
            <StatusDot $active={activeDays.length > 0} />
            {activeDays.length > 0 ? "Ativo" : "Inativo"}
          </MetaItem>
        </MetaRow>
      </TripCardBody>

      <TripCardFooter>
        {ALL_DAYS.map((day) => (
          <DayChip key={day.key} $active={activeDays.includes(day.key)}>
            {day.label}
          </DayChip>
        ))}
      </TripCardFooter>
    </TripCard>
  );
}
export default TabelaV;
